var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "new-password" }, [
    _c("div", { staticClass: "center" }, [
      _c("h1", [_vm._v(_vm._s(_vm.$t("newPasswordPage.title")))]),
      _c(
        "form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submit.apply(null, arguments)
            },
          },
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.newPassword,
                expression: "newPassword",
              },
            ],
            staticClass: "password-input",
            attrs: { type: "password" },
            domProps: { value: _vm.newPassword },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.newPassword = $event.target.value
              },
            },
          }),
          _c(
            "button",
            { staticClass: "submit-button", attrs: { type: "submit" } },
            [_vm._v(_vm._s(_vm.$t("newPasswordPage.submitButton")))]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }